import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

// Qualquer módulo do grupo Corban ativo na conta (mesma regra do menu lateral).
export const CORBAN_FEATURES = [
  FEATURE_FLAGS.TALKVIA_CORBAN,
  FEATURE_FLAGS.TALKVIA_CORBAN_FACTA_OFFLINE,
  FEATURE_FLAGS.TALKVIA_CORBAN_CLT_FGTS_QUERY,
  FEATURE_FLAGS.TALKVIA_CORBAN_BENEFIT360,
  FEATURE_FLAGS.TALKVIA_CORBAN_CREDIT_ENGINE,
  FEATURE_FLAGS.TALKVIA_CORBAN_MANUAL_SIMULATORS,
  FEATURE_FLAGS.TALKVIA_CORBAN_PROPOSAL_PIPELINE,
];

export function useCorbanModule() {
  const route = useRoute();
  const isFeatureEnabledonAccount = useMapGetter(
    'accounts/isFeatureEnabledonAccount'
  );
  const hasCorbanModule = computed(() => {
    const isEnabled = isFeatureEnabledonAccount.value;
    if (typeof isEnabled !== 'function') return false;
    const accountId = Number(route.params.accountId);
    return CORBAN_FEATURES.some(feature => isEnabled(accountId, feature));
  });
  return { hasCorbanModule };
}
